export type Indexes = {
  [key: string]: {
    keyPath: string | string[];
    parameters?: IDBIndexParameters;
  };
};

/**
 * @description
 * Create indexes for a store.
 * Must be called in the IDBDatabase onupgradeneeded event handler.
 */
export const create = (store: IDBObjectStore, indexes: Indexes) => {
  for (const [name, index] of Object.entries(indexes)) {
    store.createIndex(name, index.keyPath, index.parameters);
  }
};
